import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Hidden, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";

import { NotVerifiedIcon, UserCircle, VerifiedIcon } from "@/assets/icons";
import { Relation } from "@/shared/domain";
import { StyledPendingChip } from "@/styles/styled";

import { StyledTableCell, StyledTableCellName, StyledTableRow } from "./styled";

type RelationsTableProps = {
    relations: Relation[];
    onRelationClick: (policyHolderId: Relation) => void;
};
const RelationsTable: FC<RelationsTableProps> = ({ relations, onRelationClick }) => {
    const { t } = useTranslation();
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell $header>{t("Common.Name")}</StyledTableCell>
                        <StyledTableCell $header>{t("User.PersonalDetails.Relationships.Relation")}</StyledTableCell>
                        <StyledTableCell $header $center>
                            {t("User.PersonalDetails.Relationships.FolderAccess")}
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {relations.map((relation) => (
                        <StyledTableRow
                            key={relation.fullName}
                            hover={!relation.isPending}
                            $pending={relation.isPending}
                            tabIndex={-1}
                            data-testid={`realtions_table-row-${relation.id}`}
                            onClick={() => relation.id > 0 && onRelationClick(relation)}
                        >
                            <StyledTableCellName>
                                <Hidden smDown>
                                    <UserCircle />
                                </Hidden>

                                {relation.fullName}
                                {relation.isPending && (
                                    <Hidden smDown>
                                        <StyledPendingChip>{t("Common.Pending")}</StyledPendingChip>
                                    </Hidden>
                                )}
                            </StyledTableCellName>
                            <StyledTableCell>{relation.relationType?.name}</StyledTableCell>
                            <StyledTableCell $center>
                                {relation.hasAccessToFile ? <VerifiedIcon /> : <NotVerifiedIcon />}
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RelationsTable;
